import { useContext, useEffect, useState } from "react";
import { LayerType } from "../../../constant/LayerType";
import MrnLayer from "./MRN/MrnLayer";
import ImportTable from "./ImportTable/ImportTable";
import OpenRoadsLayer from "./OpenRoads/OpenRoads";
import OsmRoadsLayer from "./OsmRoads/OsmRoads";
import PublicTransportLayer from "./PublicTransport/PublicTransport";
import { LayerInfo } from "../../../types/LayerAdmin/LayerInfo";
import LoadingSpinner from "../../Loading/LoadingSpinner";
import { useNavigate, useParams } from "react-router-dom";
import { LayerImportResponse } from "../../../types/LayerAdmin/LayerImport";
import LayerProvider from "./LayerProvider";
import { LayerAdminServiceContext } from "./LayerAdminServiceContext";
import OsmPoiLayer from "./OsmPoi/OsmPoi";
import OSHighwaysNavigation from "./OSHighways/OSHighwaysNavigation";
import RouteLinesLayer from "./RouteLine/RouteLines";
import OsPoiLayer from "./OsPoi/OsPoi";
import OSCodePointLayer from "./OSCodePoints/OSCodePoints";

const LayerRoutes = () => {
  const [layerInfo, setLayerInfo] = useState<LayerInfo>();
  const [loading, setLoading] = useState(false);
  const [importsLoading, setImportsLoading] = useState(false);
  const { layerAdminService } = useContext(LayerAdminServiceContext)!;
  const { layerName } = useParams();
  const navigate = useNavigate();
  const [refreshToggle, setRefreshToggle] = useState(false);

  useEffect(() => {
    if (!layerName) return;
    setLoading(true);
    layerAdminService
      .getLayerInfo(layerName)
      .then((x) => {
        if (!x.allowImport) {
          navigate("/admin/layers");
        }
        setLayerInfo(x);
      })
      .catch(() => {
        navigate("/admin/layers");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [layerName, refreshToggle]);

  const refreshLayerInfo = () => {
    setRefreshToggle((prev) => !prev);
  };

  const setImportsPage = (page: number) => {
    if (!layerInfo) return;
    setImportsLoading(true);
    layerAdminService
      .GetImports(layerInfo.layerName, page)
      .then((response: LayerImportResponse) => {
        setLayerInfo({ ...layerInfo, imports: response });
      })
      .catch(() => {})
      .finally(() => {
        setImportsLoading(false);
      });
  };

  const renderLayer = (layerInfo: LayerInfo) => {
    switch (layerInfo.layerName as LayerType) {
      case LayerType.OS_MRN:
        return <MrnLayer />;
      case LayerType.OS_OPEN_ROADS:
        return <OpenRoadsLayer />;
      case LayerType.OSM_ROADS:
        return <OsmRoadsLayer />;
      case LayerType.OSM_POI:
        return <OsmPoiLayer />;
      case LayerType.PUBLIC_TRANSPORT:
        return <PublicTransportLayer />;
      case LayerType.ROUTE_LINES:
        return <RouteLinesLayer />;
      case LayerType.OS_POI:
        return <OsPoiLayer />;
      case LayerType.OS_HIGHWAYS:
        return <OSHighwaysNavigation />;
      case LayerType.OS_CODE_POINTS:
        return <OSCodePointLayer />;
      default:
        return <ImportTable />;
    }
  };

  return (
    <>
      {layerInfo && !loading && (
        <LayerProvider
          layerInfo={layerInfo}
          setLayerInfo={setLayerInfo}
          setImportPage={setImportsPage}
          layerAdminService={layerAdminService}
          importsLoading={importsLoading}
          refreshLayerInfo={refreshLayerInfo}
        >
          {renderLayer(layerInfo)}
        </LayerProvider>
      )}

      {loading && <LoadingSpinner />}
      {!layerName && <p>No layer selected</p>}
    </>
  );
};

export default LayerRoutes;
